import React from 'react';
import { CheckIcon, ClockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, cta, launchOffer, priceIncludes, priceIncludesTitle } from '../data/content';
export function Pricing() {
  return <section id="precio" className="bg-night" data-id="element-170" data-mp="2oi7fvhjl3my0">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-171" data-mp="2jjw6f7x7begb">
        <div className="mx-auto max-w-2xl text-center" data-id="element-172" data-mp="2jlpcom3wjwns">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" style={{
          fontSize: "32px"
        }} data-id="element-173" data-mp="1vv350vxt8eeb">
            GPS Bíblico + 5 bonos, en un solo pago
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-174" data-mp="25tsogt5cu6wo">
            {launchOffer.detail}
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-3xl border border-gold-soft/50 bg-night-panel p-6 sm:p-8 lg:p-10" data-id="element-175" data-mp="3h74lak2p5p9c">
          <p className="flex items-center justify-center gap-2 rounded-full bg-gold/10 px-4 py-2 text-center font-sans text-xs font-semibold uppercase tracking-[0.12em] text-gold-soft" data-id="element-176" data-mp="3c93301d3htyx">
            <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-177" data-mp="4smdyphto1y9" />
            {launchOffer.note}
          </p>

          <div className="mt-7 text-center" data-id="element-178" data-mp="9rz2rfs97j3h">
            <p className="font-sans text-base text-parchment/45" data-id="element-179" data-mp="9q5szrmcgir9">
              Precio habitual <span className="line-through" data-id="element-180" data-mp="eqtiu9yu6tjw">{launchOffer.regularPrice}</span>
            </p>
            <p className="mt-1 font-sans text-sm font-semibold uppercase tracking-[0.14em] text-parchment" data-id="element-181" data-mp="3daa960wu09ay">
              Precio actual
            </p>
            <p className="font-display text-5xl font-semibold text-gold-soft sm:text-6xl" data-id="element-182" data-mp="3n7ew42yi48st">
              {launchOffer.price}
            </p>
            <p className="mt-1 font-sans text-sm font-semibold text-gold" data-id="element-183" data-mp="3ryn3ktg9tk3c">
              {launchOffer.saveLabel}
            </p>
          </div>

          <div className="mt-7" data-id="element-184" data-mp="2zhkjnmi3gm93">
            <CtaButton size="block" href={checkoutUrl} data-id="element-185" data-mp="2zgr7u74a36k3">
              {cta.label}
            </CtaButton>
            <p className="mt-3 text-center font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-186" data-mp="2rftdidf81ngp">
              {cta.microcopy}
            </p>
            <p className="mt-1 text-center font-sans text-xs text-parchment/60 sm:text-sm" data-id="element-187" data-mp="2mfp75g812947">
              {launchOffer.paymentNote}
            </p>
          </div>

          <p className="mt-8 border-t border-night-line pt-7 text-left font-sans text-sm font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-188" data-mp="2w8mi91aowvss">
            {priceIncludesTitle}
          </p>
          <ul className="mt-4 space-y-3 text-left" data-id="element-189" data-mp="23jz3zpocz6oq">
            {priceIncludes.map(item => <li key={item} className="flex gap-3" data-id="element-190" data-mp="2ih7xoq14wmjm">
                <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold-soft" aria-hidden="true" data-id="element-191" data-mp="2idtwvm84clea" />
                <span className="font-sans text-[0.95rem] text-parchment/80" data-id="element-192" data-mp="3tuab5c7xsvzk">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}